import { useUserStore } from "~/stores/usuario_store";
// import { Popover } from "flowbite";

export const countCaracteres = (texto) => {
  if (texto != undefined) {
    return texto.length;
  }
};

export const formatNumber = (value) => {
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
}

// export const maskValor = (valor) => {
//   // Converte o valor para um número e depois para uma string com duas casas decimais
//   console.log(valor);
//   const numberValue = parseFloat(valor) / 100;
//   return numberValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s?R\$/g, '');
// };

export const maskValor = (valor) => {
  if (!valor) return '0,00';
  // Remove caracteres não numéricos e converte para número
  const cleanedValue = valor.replace(/\D/g, '');
  const numberValue = parseFloat(cleanedValue) / 100; // Divide por 100 para manter o formato em reais
  return numberValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\s?R\$/g, '');
};

export const maskValorSemCifrao = (valor) => {
  if (valor == 0) return;
  // Converte o valor para um número e depois para uma string com duas casas decimais
  const digitos = valor.replace(/\D/g, "");
  const _v1 = maskValor(digitos);
  return _v1;
}

// export const marcaraNumero = (event) => {
//   if (
//     event.target.value == 'NaN'
//     || event.target.value == 'Na'
//     || event.target.value == 'N'
//     || event.target.value == ''
//     || event.target.value == null
//   ) event.target.value = '0,00';

//   const digitos = event.target.value.replace(/\D/g, "");
//   const _v1 = maskValor(digitos);
//   event.target.value = _v1;

//   // const onlyDigits = event.target.value
//   //   .split("")
//   //   .filter((s) => /\d/.test(s))
//   //   .join("")
//   //   .padStart(3, "0");
//   // const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2);
//   // event.target.value = maskValor(digitsFloat);
// };

export function formatarNumeroBR(numero) {
  return new Intl.NumberFormat('pt-BR').format(numero);
}

export const marcaraNumero = (event, item, field) => {
  let value = event.target.value;

  // Remove caracteres não numéricos
  value = value.replace(/\D/g, '');
  if (!value) {
    event.target.value = '0,00';
    item[field] = '0,00';
    return;
  }

  // Converte para número em reais (divide por 100)
  const numberValue = parseFloat(value) / 100;
  const formattedValue = numberValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Atualiza o input e o estado reativo
  event.target.value = formattedValue;
  item[field] = formattedValue; // Armazena o valor formatado (ex.: "0,99")
};

export function validateEmail(email) {
  if (email.length == 0) return true;
  return /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/.test(email);
}

export function validaTelefone(celular, obrigatorio = true) {
  if ((celular == undefined || celular == "" || celular.length == 0) && obrigatorio == false) return true;
  celular = celular.replace(/[^\d]+/g, "");
  return celular.match(/^\(?(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])\)? ?(?:[2-8]|9[1-9])[0-9]{3}\-?[0-9]{4}$/);
}

export function duplicidadeCpf(inputCPF) {
  if (!validarCPF(inputCPF)) return false;

  return true;
}

export function validaCEP(cep) {
  cep = cep.replace(/[^0-9]/gi, "");
  if (cep.length == 8) {
    return true;
  }
  return false;
}

export function validarCPF(inputCPF) {
  var soma = 0;
  var i;
  var resto;
  if (inputCPF.length == 0) return true;

  inputCPF = inputCPF.replace(/[^\d]+/g, "");

  if (inputCPF == "00000000000") return false;
  for (i = 1; i <= 9; i++) soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(inputCPF.substring(9, 10))) return false;

  soma = 0;
  for (i = 1; i <= 10; i++) soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(inputCPF.substring(10, 11))) return false;
  return true;
}

export function validaCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj == "") return true;

  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (var i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (var i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}

export function formatPrice(value) {
  let val = (value / 1).toFixed(2).replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const slugify = (text) => {
  // if (text == null) return;
  return text
    .toString()
    .toLowerCase()
    .replace(/[àÀáÁâÂãäÄÅåª]+/g, "a") // Special Characters #1
    .replace(/[èÈéÉêÊëË]+/g, "e") // Special Characters #2
    .replace(/[ìÌíÍîÎïÏ]+/g, "i") // Special Characters #3
    .replace(/[òÒóÓôÔõÕöÖº]+/g, "o") // Special Characters #4
    .replace(/[ùÙúÚûÛüÜ]+/g, "u") // Special Characters #5
    .replace(/[ýÝÿŸ]+/g, "y") // Special Characters #6
    .replace(/[ñÑ]+/g, "n") // Special Characters #7
    .replace(/[çÇ]+/g, "c") // Special Characters #8
    .replace(/[ß]+/g, "ss") // Special Characters #9
    .replace(/[Ææ]+/g, "ae") // Special Characters #10
    .replace(/[Øøœ]+/g, "oe") // Special Characters #11
    .replace(/[%]+/g, "pct") // Special Characters #12
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
};

export const base64 = (v) => {
  return btoa(v);
};

export const base64Decode = (v) => {
  return atob(v);
};

//Logoff pode ser acessador de qualquer local do sistema
//envia para a pagina inicial logo apos o logoff
export const logOff = () => {
  const userStore = useUserStore();
  userStore.setLogoff();

  navigateTo("/");
};

export const dateBrazilFormatFull = (d) => {
  const date = new Date(d);

  let options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/Sao_Paulo",
    timeZoneName: "short",
  };

  let _ret = new Intl.DateTimeFormat("pt-BR", options).format(date);
  return _ret;
};

export const dateBrazilFormat = (d) => {
  const date = new Date(d);

  let options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
    timeZone: "America/Sao_Paulo",
  };
  let _ret = new Intl.DateTimeFormat("pt-BR", options).format(date);
  return _ret;
};

/**
 * Funcão para retirar acentos de uma string
 */
export const removeAcento = (text) => {
  return text.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}


/**
 * replaceBodyMail
 * @param {String} _text
 * @returns String texto do email com string substituídas
 */
export const replaceBodyMail = (_text) => {
  let textRet = _text;
  textRet = textRet.replaceAll("{{OBJETO}}", "'troca/devolução'");
  textRet = textRet.replaceAll("{{STATUS}}", "'Novo Status'");
  textRet = textRet.replaceAll("{{REFERENCIA}}", "'referência'");
  textRet = textRet.replaceAll("{{DATACOMPRA}}", "'00/00/0000'");
  textRet = textRet.replaceAll("{{VENCIMENTOBOLETO}}", "'00/00/0000'");
  textRet = textRet.replaceAll("{{TIPOPAGAMENTO}}", "'cartão de credito/pix/boleto/loterica'");
  textRet = textRet.replaceAll("{{VALOR}}", "'R$ 123,00'");
  textRet = textRet.replaceAll("{{EMPRESANOME}}", "'Empresa X'");
  textRet = textRet.replaceAll("{{CODIGOVERIFICACAO}}", "'Código de Verificação'");
  textRet = textRet.replaceAll("{{NOMELOJA}}", "'Empresa X'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGARUA}}", "'Rua'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGAMUMERO}}", "'número'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGABAIRRO}}", "'bairro'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGACOMPLEMENTO}}", "'complemento'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGAREFERENCIAS}}", "'referencias'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGACEP}}", "'00000-000'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGACIDADE}}", "'cidade'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGAESTADO}}", "'estado'");
  textRet = textRet.replaceAll("{{ENDERECOENTREGARUA}}", "''");
  textRet = textRet.replaceAll(
    "{{LISTADOCUMENTOS}}",
    `<ul>
        <li>Documento 01</li>
        <li>Documento 02</li>
        <li>Documento 03</li>
        <li>Documento 04</li>
      </ul>`
  );
  textRet = textRet.replaceAll(
    "{{PRODUTOS}}",
    `<table class="table" style="margin-top: 30px;">
        <tbody>
            <tr>
                <td>ID</td>
                <td>Imagem</td>
                <td>Valor</td>
            </tr>
            <tr>
                <td>123</td>
                <td>img</td>
                <td>123,00</td></td>
            </tr>
        </tbody>
    </table>`
  );

  return textRet;
};

export function geraIntervaloEmHoras(startHourInMinute, endHourInMinute, interval) {
  const times = [];

  for (let i = 0; startHourInMinute < 24 * 60; i++) {
    if (startHourInMinute > endHourInMinute) break;

    var hh = Math.floor(startHourInMinute / 60);

    var mm = startHourInMinute % 60;

    times[i] = ("0" + (hh % 24)).slice(-2) + ":" + ("0" + mm).slice(-2);

    startHourInMinute = startHourInMinute + interval;
  }

  return times;
}

export function clearPhoneNumber(number) {
  let tempNumber = number.replace(/\D/g, "");
  return tempNumber;
}


export function validateFields(item) {
  if (item == false) return false
  if (item == 'false') return false
  if (item == null) return false
  if (item == 'null') return false
  if (item == undefined) return false
  if (item == 'undefined') return false
  if (item.length < 1) return false
  return true
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.substring(1);
}